import Icon from '../components/Icon.vue'

Icon.register({
  'wine-bottle': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M507.3 72.6c6.3 6.3 6.3 16.4 0 22.6l-22.6 22.6c-6.3 6.3-16.4 6.3-22.6 0l-76.7 76.7c19.7 46.6 10.7 102.4-27.2 140.4l-158.4 158.4c-25 25-65.5 25-90.5 0l-90.5-90.5c-25-25-25-65.5 0-90.5l158.4-158.4c38-38 93.8-46.9 140.4-27.2l76.7-76.7c-6.3-6.3-6.3-16.4 0-22.6l22.6-22.6c6.3-6.3 16.4-6.3 22.6 0zM179.2 423.3l122-122-90.5-90.5-122 122z'
      }
    ]
  }
})
